<template>
  <div class="chart flex-column flex-justify-start flex-align-start" :class="[{'card-gap': gap}]">
    <div class="chart1 flex-column flex-justify-start flex-align-start">
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==1">周期内用电趋势</div>
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==2">周期内用水趋势</div>
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==3">周期内用气趋势</div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==1">
        <div id="nhdref" class="chart-area"></div>
      </div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==2">
        <div id="nhsref" class="chart-area"></div>
      </div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==3">
        <div id="nhqref" class="chart-area"></div>
      </div>
    </div>
    <div class="chart1 flex-column flex-justify-start flex-align-start" :class="[{'card-gap': gap}]">
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==1">周期内用电最大电表(10个)</div>
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==2">周期内用电最大水表(10个)</div>
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==3">周期内用电最大气表(10个)</div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==1">
        <div class="chart-area">
          <div class="tb-head flex-row flex-justify-start flex-align-center">
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>编号</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 25%;">
              <span>设备名称</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 35%;">
              <span>位置</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>周期内用电量</span>
            </div>
          </div>
          <div class="tb-line flex-row flex-justify-start flex-align-center" v-for="(item, index) in tableData.maxmeters" :key="index">
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>{{ item.id }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 25%;">
              <span>{{ item.name }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 35%;">
              <span>{{ item.location }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>{{ item.value }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==2">
        <div class="chart-area">
          <div class="tb-head flex-row flex-justify-start flex-align-center">
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>编号</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 25%;">
              <span>设备名称</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 35%;">
              <span>位置</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>周期内用水量</span>
            </div>
          </div>
          <div class="tb-line flex-row flex-justify-start flex-align-center" v-for="(item, index) in tableData.maxmeters" :key="index">
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>{{ item.id }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 25%;">
              <span>{{ item.name }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 35%;">
              <span>{{ item.location }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>{{ item.value }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==3">
        <div class="chart-area">
          <div class="tb-head flex-row flex-justify-start flex-align-center">
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>编号</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 25%;">
              <span>设备名称</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 35%;">
              <span>位置</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>周期内用气量</span>
            </div>
          </div>
          <div class="tb-line flex-row flex-justify-start flex-align-center" v-for="(item, index) in tableData.maxmeters" :key="index">
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>{{ item.id }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 25%;">
              <span>{{ item.name }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 35%;">
              <span>{{ item.location }}</span>
            </div>
            <div class="flex-row flex-justify-center flex-align-center" style="width: 20%;">
              <span>{{ item.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chart1 flex-column flex-justify-start flex-align-start" :class="[{'card-gap': gap}]" style="margin-bottom: 20px;">
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==1">周期内用电异常表</div>
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==2">周期内用水异常表</div>
      <div class="chart-head flex-row flex-justify-start flex-align-start" v-if="charttype==3">周期内用气异常表</div>
      <div class="ds-item flex-row flex-justify-start flex-align-center">
        <div class="dsi-text">选择表具：</div>
        <el-select v-model="selid" placeholder="请选择" @change="handleErrList" style="width: calc(90% - 100px)">
          <el-option
            v-for="item in tableData.errlist"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==1">
        <div id="nhderef" class="chart-area"></div>
      </div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==2">
        <div id="nhseref" class="chart-area"></div>
      </div>
      <div class="chart-contain flex-row flex-justify-center flex-align-start" v-if="charttype==3">
        <div id="nhqeref" class="chart-area"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {getMonNenghao} from '@/api/engery.js'
import * as echarts from 'echarts'
import { error } from 'three';

export default {
  name: 'NhChart',
  props: {
    gap: {
      type: Boolean,
      default: true
    },
    charttype: {
      type: Number,
      default: 1
    },
    initdone: {
      type: Boolean,
      default: false
    },
    timedate: {
      type: Object,
      default: () => ({
        starttime: '',
        endtime: ''
      })
    }
  },
  data() {
    return {
      chart: null,
      charte: null,
      tableData: {
        xdata: [],
        y1data: [],
        y2data: [],
        maxmeters: [],
        errlist: []
      },
      selid: '',
      selerr: {}
    }
  },
  watch: {
    initdone: {
      handler() {
        this.$nextTick(async () => {
          let date1 = new Date(this.timedate.starttime)
          let date2 = new Date(this.timedate.endtime)
          if(date1 > date2) {
            if(this.charttype == 1) this.$message.error('开始时间不能大于结束时间')
            return
          }
          const days = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24))
          if(days > 31) {
            if(this.charttype == 1) this.$message.error('只能分析一个月内的数据')
            return
          }
          let xdata = []
          while(date1 <= date2) {
            const year = date1.getFullYear()
            const month = String(date1.getMonth() + 1).padStart(2, '0')
            const day = String(date1.getDate()).padStart(2, '0')
            const dt = `${month}-${day}`
            xdata.push(dt)
            date1.setDate(date1.getDate() + 1)
          }
          let devtype = ''
          if(this.charttype == 1) {
            devtype = '电表'
          }
          else if(this.charttype == 2) {
            devtype = '水表'
          }
          else if(this.charttype == 3) {
            devtype = '冷气表'
          }
          const param = {
            devtype: devtype,
            startTime: this.timedate.starttime,
            endTime: this.timedate.endtime
          }
          try {
            const response = await getMonNenghao(xdata, param)
            this.tableData.xdata = response.data.xdata
            this.tableData.y1data = response.data.y1data
            this.tableData.y2data = response.data.y2data
            this.tableData.errlist = response.data.errlist
            this.tableData.maxmeters = response.data.maxmeters
            if(this.tableData.errlist.length > 0) {
              this.selid = this.tableData.errlist[0].id
              this.selerr = this.tableData.errlist[0]
            }
            this.initChart()
            this.initCharte()
          } catch (error) {
            if(this.charttype == 1) console.error(error)
          }
        })
      },
      deep: true
    },
  },
  beforeDestroy() {
    if(this.chart != null) {
      this.chart.dispose()
      this.chart = null
    }
    if(this.charte != null) {
      this.charte.dispose()
      this.charte = null
    }
  },
  methods: {
    handleErrList(value) {
      if(this.charte != null) {
        this.charte.dispose()
        this.charte = null
      }
      const meters = this.tableData.errlist.filter(item => item.id == value)
      if(meters.length > 0) {
        this.selerr = meters[0]
        this.initCharte()
      }
    },
    initChart() {
      var chartDom = null
      let danwei = ''
      let legend = []
      if(this.charttype == 1) {
        chartDom = document.getElementById('nhdref')
        if(!chartDom) {
          return
        }
        legend = ['今年电量', '去年电量']
        danwei = 'kWh'
      }
      else if(this.charttype == 2) {
        chartDom = document.getElementById('nhsref')
        if(!chartDom) {
          return
        }
        legend = ['今年水量', '去年水量']
        danwei = '吨'
      }
      else if(this.charttype == 3) {
        chartDom = document.getElementById('nhqref')
        if(!chartDom) {
          return
        }
        legend = ['今年用气', '去年用气']
        danwei = 'm³'
      }
      if (!this.chart) {
        this.chart = echarts.init(chartDom);
      }
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'text-align: left;',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: legend
        },
        xAxis: [
          {
            type: 'category',
            data: this.tableData.xdata,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: danwei,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: legend[0],
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#08affe'
            },
            data: this.tableData.y1data
          },
          {
            name: legend[1],
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#6bc26b'
            },
            data: this.tableData.y2data
          }
        ]
      }
      this.chart.setOption(option)
    },
    initCharte() {
      var chartDom = null
      let danwei = ''
      let legend = []
      if(this.charttype == 1) {
        chartDom = document.getElementById('nhderef')
        if(!chartDom) {
          return
        }
        legend = ['今年电量', '去年电量']
        danwei = 'kWh'
      }
      else if(this.charttype == 2) {
        chartDom = document.getElementById('nhseref')
        if(!chartDom) {
          return
        }
        legend = ['今年水量', '去年水量']
        danwei = '吨'
      }
      else if(this.charttype == 3) {
        chartDom = document.getElementById('nhqeref')
        if(!chartDom) {
          return
        }
        legend = ['今年用气', '去年用气']
        danwei = 'm³'
      }
      if (!this.charte) {
        this.charte = echarts.init(chartDom);
      }
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'text-align: left;',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: legend
        },
        xAxis: [
          {
            type: 'category',
            data: this.selerr.xdata,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: danwei,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: legend[0],
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#08affe'
            },
            data: this.selerr.y1data
          },
          {
            name: legend[1],
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#6bc26b'
            },
            data: this.selerr.y2data
          }
        ]
      }
      this.charte.setOption(option)
    }
  }
}

</script>

<style scoped>
.chart {
  width: 33%;
}
.chart1 {
  margin-top: 10px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.card-gap {
  margin-right: 0.5%;
}
.chart-head {
  font-family: 'Arial';
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
  margin-top: 10px;
}
.chart-area {
  min-width: 520px;
  min-height: 260px;
}
.tb-head {
  width: 96%;
  min-height: 30px;
  margin-top: 10px;
  background-color: #e8f1ff;
  font-family: 'Arial';
  font-size: 14px;
  color: #3d5ad0;
}
.tb-line {
  width: 96%;
  min-height: 30px;
  font-family: 'Arial';
  font-size: 14px;
  color: #c0c0c0;
}
.ds-item {
  width: 100%;
  margin-left: 10px;
  margin-top: 10px;
  overflow: hidden;
}
.dsi-text {
  font-family: 'Arial';
  font-size: 16px;
  text-align: left;
}
.chart-contain {
  width: 100%;
  overflow: hidden;
}
</style>
